export default "__VITE_ASSET__f527472e__"